import React from 'react';
import '../styles/videocard.css';
import { Link } from 'react-router-dom';
import { PlayCircleOutline } from '@material-ui/icons';
import '../styles/AllVideoRow.css';

const VideoCard = ({ videoTitle, description, videoImg }) => {
  return (
    <div className="videocard">
      <Link to="video/video_id" className="suggestionvidoerow__link">
        <img className="videocard__img" src={videoImg} alt="" />
        <PlayCircleOutline className="videocard__playicon" fontSize="large" />
        <div className="Suggestionvideocard__body">
          <h3>{videoTitle}</h3>
          <p> {description}</p>
        </div>
      </Link>
    </div>
  );
};

export default VideoCard;
